export default __webpack_public_path__ + "static/media/typing-bubble-icon.41a7a521.svg";